import { Component, computed, effect, input, output, signal } from '@angular/core';
import { KanaalSelection, KanaalSelectorBase } from '../kanaal-selector/KanaalSelectorBase';
import { AnalogIn, AnalogOut, DigitalIn, DigitalOut, IOType, ModBusIn, ModBusOut, MqttIn, MqttOut, RangedKanaal, RangedKanaalAssign } from '../../props/PropTypes';
import { HwdConfigService } from '../hwd-config.service';
import { HwdSysteem } from '../hdw-config/HdwSysteem';
import { buildKanaalMap, checkAssignPredicate, getAvailableRanges, kanaalLabel } from '../kanaal.utils';

@Component({
  selector: 'hdwv-kanaal-selector',
  templateUrl: './hdwv-selector.component.html',
  styleUrl: './hdwv-selector.component.scss'
})
export class HdwvSelectorComponent {

  constructor() { }

  public kanaalType = input<IOType>();
  public range = input<number>(1);
  public assign = input.required<RangedKanaalAssign[]>();
  public system = input<HwdSysteem>();
  // public selection = signal<KanaalSelection>({});
  public onKanaalSelected = output<KanaalSelection>();

  public initialSelection = input<KanaalSelection>({});

  public kanaalMap = computed(() => {

    return buildKanaalMap(this.assign());
  });



  public extras = computed(() => {
    let ret: Record<string, Array<RangedKanaalAssign>> = {};
    let assignement = this.assign();
    ret[ModBusIn.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(ModBusIn));
    ret[ModBusOut.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(ModBusOut));
    ret[MqttIn.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(MqttIn));
    ret[MqttOut.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(MqttOut));
    return ret;
  });

  public hdwMax = computed(() => {
    let s = this.system();
    let max: Record<string, number> = {
      [DigitalIn.toString()]: 0,
      [DigitalOut.toString()]: 0,
      [AnalogIn.toString()]: 0,
      [AnalogOut.toString()]: 0
    };
    if (s != undefined) {
      let hdwIOS = s.getAllIOs();
      for (let io of hdwIOS) {
        if (io.ioType.equals(DigitalIn)) {
          max[DigitalIn.toString()] = Math.max(max[DigitalIn.toString()], io.start + io.range - 1);
        }
        if (io.ioType.equals(DigitalOut)) {
          max[DigitalOut.toString()] = Math.max(max[DigitalOut.toString()], io.start + io.range - 1);
        }
        if (io.ioType.equals(AnalogIn)) {
          max[AnalogIn.toString()] = Math.max(max[AnalogIn.toString()], io.start + io.range - 1);
        }
        if (io.ioType.equals(AnalogOut)) {
          max[AnalogOut.toString()] = Math.max(max[AnalogOut.toString()], io.start + io.range - 1);
        }
      }
    }
    return max;
  });

  public kanaalMaxLabel(type: string) {
    switch (type) {
      case AnalogIn.toString():
        return kanaalLabel(this.hdwMax()[type], AnalogIn);
      case AnalogOut.toString():
        return kanaalLabel(this.hdwMax()[type], AnalogOut);
      case DigitalIn.toString():
        return kanaalLabel(this.hdwMax()[type], DigitalIn);
      case DigitalOut.toString():
        return kanaalLabel(this.hdwMax()[type], DigitalOut);
    }
  }

  public hdwOutOfRange = computed(() => {
    let assignement = this.assign();
    let ret: Record<string, Array<RangedKanaalAssign>> = {};
    let s = this.system();
    if (s != undefined) {
      let hdwAvailableRanges = getAvailableRanges(s);
      ret[AnalogIn.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(AnalogIn) && !checkAssignPredicate(a, hdwAvailableRanges[AnalogIn.toString()]));
      ret[AnalogOut.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(AnalogOut) && !checkAssignPredicate(a, hdwAvailableRanges[AnalogOut.toString()]));
      ret[DigitalIn.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(DigitalIn) && !checkAssignPredicate(a, hdwAvailableRanges[DigitalIn.toString()]));
      ret[DigitalOut.toString()] = assignement.filter(a => a.rangedKnaal.ioType.equals(DigitalOut) && !checkAssignPredicate(a, hdwAvailableRanges[DigitalOut.toString()]));

    }
    return ret;
  });

  public hasOutOfRange = computed(() => {
    let ret = false;
    for (let key in this.hdwOutOfRange()) {
      if (this.hdwOutOfRange()[key].length > 0) {
        ret = true;
      }
    }
    return ret;
  });



  protected isValidSelection(e: KanaalSelection) {
    let kanaal = e.kanaal?.start;
    if (kanaal == undefined) {
      return false;
    }
    let kType = this.kanaalType();
    if (kType != undefined && !kType.equals(e.kanaal?.ioType)) {
      return false;
    }
    if (kType?.equals(AnalogIn) && this.range() == 2) {
      return kanaal % 2 == 0;
    }
    return true;
  }

  onSelectionChange(e: KanaalSelection) {
    if (this.isValidSelection(e)) {
      this.onKanaalSelected.emit(e);
    }
  }


}
